function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M11.889 1H4.11A3.111 3.111 0 001 4.111v7.778A3.111 3.111 0 004.111 15h4.372V9.586H6.661v-2.12h1.822V5.907c0-1.808 1.105-2.793 2.718-2.793a15.23 15.23 0 011.627.082v1.89h-1.11c-.88 0-1.05.415-1.05 1.028v1.35h2.1l-.273 2.119h-1.84V15h1.234A3.111 3.111 0 0015 11.889V4.11A3.111 3.111 0 0011.889 1z"
});

function SvgFacebookFooterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgFacebookFooterinline;